<script lang="ts">
  import Button from './Button.svelte';
  import Checkbox from './checkbox/Checkbox.svelte';

  export let agreedToTerms: boolean;
  export let onSubmit: () => void;
</script>

<div class="p-2">
  <p>
    Now that you've onboarded onto our community platform, there are a few key resources and dates
    to know about:
  </p>
  <ul
    class="text-gray-dark-11 mb-6 list-outside list-disc pl-6 pr-6 text-sm font-normal leading-[1.3rem]"
  >
    <li class="mt-4">
      <strong>Get Ready to Build:</strong>
      Colosseum powers Solana Foundation hackathons. We will notify all Colosseum users regarding the
      details of the next hackathon soon.
    </li>
    <li class="mt-4">
      <strong>Find Cofounders:</strong> Browse the directory for other builders in the community who
      could be potential teammates. Use the native messaging functionality to introduce yourself, and
      don't be shy!
    </li>
    <li class="mt-4">
      <strong>Share Product Ideas:</strong> Post or provide feedback within the product forum about potential
      ideas that could be built during the next hackathon. There is also a forum for builders to introduce
      themselves and explain who they're looking to team up with.
    </li>
    <li class="mt-4">
      <strong>Code of Ethics:</strong> Colosseum is a community of builders who are dedicated to
      growing the crypto economy. Our community not only supports each other in that mission, but
      also follows a shared code of ethics. Please review
      <a class="text-mint-dark-9" target="_blank" href="https://www.colosseum.org/code-of-ethics"
        >Colosseum's Code of Ethics</a
      > before posting in the forum.
    </li>
    <li class="mt-4">
      <strong>Colosseum's Accelerator:</strong> Hackathon winners will be interviewed for acceptance
      into our accelerator program that provides mentorship, access to an elite network of founders,
      and an investment from Colosseum's venture fund.
      <a class="text-mint-dark-9" target="_blank" href="https://www.colosseum.org/accelerator"
        >Learn more about the program.</a
      >
    </li>
  </ul>
  <p>
    We are so excited to work with the community on improving our hackathons and adding lots more
    functionality to this platform. Make sure to <a
      class="text-mint-dark-9"
      target="_blank"
      href="https://x.com/colosseum">follow Colosseum on X</a
    > for upcoming announcements.
  </p>
  <div class="mt-7 flex w-full items-center justify-between pl-1 pr-1">
    <Checkbox label="I agree to follow Colosseum's Code of Ethics" bind:checked={agreedToTerms} />
    <Button primary size="md" disabled={!agreedToTerms} on:click={onSubmit} class="ml-8">
      Submit
      <img class="w-4" src="/images/png/favicon-colosseum-32x32.png" alt="colosseum logomark" />
    </Button>
  </div>
</div>
